/**
 * SEO component that queries for data with
 * Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { useLocation } from '@reach/router';
import { Lang, LangEnum } from "../utils/lang"

function Seo({ description, title, metatags, children }) {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  let paramsString = ''
  params.forEach((value, key) => {
    if (key.startsWith('_')) return;
    paramsString += `\n${key}: ${value}`;
  })
  // console.log(paramsString)
  // console.log(metatags)

  // Add whitelist of pages that should have hreflang tags
  const hreflangWhitelist = [
    '/', 
    '/home/', 
    '/flight/',   
    '/about-amnet-new-york-inc/', 
    '/contact/',
    '/privacy-policy/',
    '/terms-conditions/',
    '/accessibility/',
    '/travel-insurance/',
    '/sim-wifi/',
    '/tours/',
    '/blogs/',
  ]

  // Create hreflang links if current path is in whitelist
  const getHreflangLinks = () => {
    const baseUrl = 'https://travelwithamnet.com'
    const lang = Lang()
    const path = location.pathname.replace(/^\/(ja\/)?/, '/') // Remove language prefix if exists
    const inWhitelist = hreflangWhitelist.includes(path)
    // console.log(path)
  
    return (
      <>
        {(inWhitelist || lang === LangEnum.EN) && 
        <>
          <link rel="alternate" hrefLang="en-us" href={`${baseUrl}${path}`} />
          <link rel="alternate" hrefLang="en-ca" href={`${baseUrl}${path}`} />
        </>}
        {(inWhitelist || lang === LangEnum.JA) &&
        <>
          <link rel="alternate" hrefLang="ja-us" href={`${baseUrl}/ja${path}`} />
          <link rel="alternate" hrefLang="ja-ca" href={`${baseUrl}/ja${path}`} />
        </>}
        <link rel="alternate" hrefLang="x-default" href={`${baseUrl}`} />
      </>
    )
  }

  
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const lang = Lang()
  const titleSuffix = lang == LangEnum.JA ? 'Travel with Amnet' : 'Travel with Amnet'

  const metaTitle = metatags?.title ? metatags.title : `${title} - ${titleSuffix}`
  const metaDescription = metatags?.description || description || `${site.siteMetadata.description}\n${metaTitle}`

  return (
    <>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={metatags?.og_title || metaTitle} />
      <meta property="og:description" content={metatags?.og_description || metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={metatags?.og_image} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={site.siteMetadata?.author || ``} />
      <meta name="twitter:title" content={metatags?.twitter_title || metaTitle } />
      <meta name="twitter:description" content={metatags?.twitter_description || metaDescription} />
      <meta name="twitter:image" content={metatags?.twitter_image} />
      {children}

      {/* favicon */}
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="manifest" href="/site.webmanifest" />
      <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#003498" />
      <meta name="msapplication-TileColor" content="#003498" />
      <meta name="theme-color" content="#ffffff"></meta>
      
      {getHreflangLinks()}
    </>
  )
}

export default Seo
